import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CopyChartService } from "../../../platform/api/copy-chart/copy-chart.service";

@Component({
    selector: "app-more-actions-modal",
    templateUrl: "./more-actions-modal.component.html",
    styleUrls: ["./more-actions-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreActionsModalComponent {
    private static readonly defaultMessage = "Bulk actions have a limit of 5000 chases.Your action will apply only to first 5000 chases in your list.Do you wish to continue ? ";

    private Visible = false;

    @Input()
    get visible(): boolean {
        return this.Visible;
    }
    set visible(value: boolean) {
        this.Visible = value;
        this.visibleChange.emit(this.visible);
    }

    private Message = MoreActionsModalComponent.defaultMessage;

    /** Falls back to the default for null/empty, so a caller can bind conditionally. */
    @Input()
    get message(): string {
        return this.Message;
    }
    set message(value: string) {
        this.Message = value || MoreActionsModalComponent.defaultMessage;
    }

    @Output() continue = new EventEmitter<void>();
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onHide = new EventEmitter<null>(true);

    constructor(
        private readonly copyChartService: CopyChartService
    ) {}


    cancel(): void {
        this.copyChartService.clearChaseGrid();
        this.onHide.emit();
    }

    onContinue(): void {
        this.continue.emit();
        this.visible = false;
    }
}

